import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBBadge,MDBTable, MDBTableBody, MDBTableHead  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, Divider   } from 'antd';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import { ThunderboltFilled } from '@ant-design/icons';
import GoogleMapReact from 'google-map-react';

const AnyReactComponent = ({ text }) => <div>{text}</div>;

export default class Modalshowroom extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   CRHR:"",
   idcolor:'',
   id_room:'',
   team:'',
   showteachingschedule:[],
   teacher:'',
   click:false,
  

}

//this.handleChange = this.handleChange.bind(this);
this.handleChange2 = this.handleChange2.bind(this);
this.handleChange3 = this.handleChange3.bind(this);
// this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
this.handleChange4 = this.handleChange4.bind(this);
//this.getExpert = this.getExpert.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.props.getclassroom();
}


 componentDidMount() {
      const { id_room } = this.props.id_room
    //  console.log(this.props.id_send);
      this.setState({ id_room:this.props.id_room})
      this.setState({ team:this.props.team})
   
      setTimeout(() => {
        //ภายใน
         Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/showstudentscheduleroom/'+this.props.team+'/'+this.props.id_room)
        .then(res => {
          console.log(res);
        //  this.setState({ bankname: res.data, loading: false })
          this.setState({ showteachingschedule: res.data})

          if (res.data.length !== 0) {
           const teacher = res.data[0].poname;
           this.setState({ teacher });
           this.setState({ click:true });

         }

        }) 
      }, 1000);


  }


  handleChange2(event) {    this.setState({id_room: event.target.value});  }
  handleChange3(event) {    this.setState({name_room: event.target.value});  }
  handleChange4(event) {    this.setState({amount: event.target.value});  }




    render() {
     //   console.log(this.state.th)
        // console.log(this.state.name_room)
        // console.log(this.state.amount)

        const defaultProps = {
            center: {
              lat: 16.453401,
              lng: 99.513710
            },
            zoom: 11
          };
        
        return (
            <MDBContainer>


           { this.state.term === '' ? <></> :<> 
           <br/>
          
           {this.state.click === false ? <>

                    {this.state.showteachingschedule.length === 0 ?<>-- ไม่มีข้อมูล --</>:<>
                    <div className="spinner-grow text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                    </div>
                    </>}
          
            </>: <>
         
            <MDBTable bordered small responsive>
                <MDBTableHead>
                <tr>
                    <th  className="text-center">ลำดับ</th>
                    <th  className="text-center">หมู่เรียน</th>
                    <th  className="text-center">โปรแกรม</th>
                    <th  className="text-center">รหัสวิชา</th>
                    <th  className="text-center">ชื่อวิชา</th>
                    <th  className="text-center">ผู้สอน</th>
                    <th  className="text-center">จำนวน</th>
                    {/* <th  className="text-center">กลุ่ม</th> */}
                    <th  className="text-center">วัน</th>
                    <th  className="text-center">เวลา</th>
                    <th  className="text-center">ห้องเรียน</th>
                </tr>
              
                </MDBTableHead>
                <MDBTableBody>
                {this.state.showteachingschedule.map((showteachingschedule,index) => {
                
                   //กศบป
                    const  time2 = Number (showteachingschedule.hour1*55)
                    const  ddf = time2-5
                    const  now = new Date("December 25, 1995 "+showteachingschedule.times1+" ");
                    const totalsss = now.setMinutes(now.getMinutes()+ddf);
                    const wanwela = new Date(totalsss)
                    const wanwela1 =  wanwela.toLocaleTimeString()

                    //ปกติ
                    const  timenormal = Number (showteachingschedule.hour1*60)
                    const  now2 = new Date("December 25, 1995 "+showteachingschedule.times1+" ");
                    const totalsss2 = now2.setMinutes(now2.getMinutes()+timenormal);
                    const wanwela2 = new Date(totalsss2)
                    const normal =  wanwela2.toLocaleTimeString()
                       
                     return   <tr>
                          <td  className="text-center">{index+1}</td>
                          <td  className="text-center">{showteachingschedule.id_major}</td>
                          <td>{showteachingschedule.t_mjname}</td>
                          <td  className="text-center">{showteachingschedule.SUBJCODE !== null ?<>{showteachingschedule.SUBJCODE.substring(0,7)}</>:<>--ไม่ระบุ--</>}</td>
                          <td>{showteachingschedule.SUBJNAME}</td>
                          <td>{showteachingschedule.prenm}{showteachingschedule.poname}</td>
                          <td  className="text-center">{showteachingschedule.numregister}</td>
                          {/* <td> <p><Modalcolor idcolor={teachingschedule.group_id} /></p></td> */}
                          {/* <td>อาจารย์{teachingschedule.poname}</td> */}

                    {/* ช่วงที่1 */}
                          <td  className="text-center"> {showteachingschedule.ss === '1' ?<> จันทร์</>:<></> }
                               {showteachingschedule.ss === '2' ?<> อังคาร</>:<></> }
                               {showteachingschedule.ss === '3' ?<> พุธ</>:<></> }
                               {showteachingschedule.ss === '4' ?<> พฤหัสบดี</>:<></> }
                               {showteachingschedule.ss === '5' ?<> ศุกร์</>:<></> }
                               {showteachingschedule.ss === '6' ?<> เสาร์</>:<></> }
                               {showteachingschedule.ss === '7' ?<> อาทิตย์</>:<></> }
                          </td>
                          <td>
                              {showteachingschedule.times1 === null || showteachingschedule.times1 === ''  ? <></> :<> {showteachingschedule.times1} - {showteachingschedule.timesend1}
                              {/* { showteachingschedule.id_major.substring(2, 3) === '1' ?<>{normal.substring(0, 5)} </> :<>{wanwela1.substring(0, 5)}  </>} */}
                                </> }
                          </td>
                          <td  className="text-center">{showteachingschedule.classroom1}</td>
                          </tr>
                  
                })}   
                </MDBTableBody>
            </MDBTable>

            {/* <div style={{ height: '100vh', width: '100%' }}>
                <GoogleMapReact
                    bootstrapURLKeys={{ key: "" }}
                    defaultCenter={defaultProps.center}
                    defaultZoom={defaultProps.zoom}
                >
                    <AnyReactComponent
                    lat={16.453401}
                    lng={99.513710}
                    text="My Marker"
                    />
                </GoogleMapReact>
            </div> */}

            </> }
            {/* <p>หมายเหตุ : ข้อมูลใช้ประกอบการจัดตารางสอน ไม่ให้ชนกับการประชุม</p> */}
        </>}
           
           

          </MDBContainer>
          
        )
    }
}
